import { render, staticRenderFns } from "./bookmark.vue?vue&type=template&id=52c90dcd&scoped=true&lang=html"
import script from "./bookmark.vue?vue&type=script&lang=js"
export * from "./bookmark.vue?vue&type=script&lang=js"
import style0 from "./bookmark.vue?vue&type=style&index=0&id=52c90dcd&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c90dcd",
  null
  
)

export default component.exports